import { GET } from './api'

const buildSearchQuery = (query, options = {}) => {
  const params = new URLSearchParams()
  params.set('q', query)
  if (options?.page) params.set('page', options.page)
  if (options?.pageSize) params.set('pageSize', options.pageSize)
  if (options?.locale) params.set('locale', options.locale)
  if (options?.version) params.set('version', options.version)
  if (options?.type) params.set('type', options.type)
  if (options?.includeRelated) params.set('includeRelated', 'true')
  return params.toString()
}

export const ReadSearch = async (query, options = {}) => {
  if (options.signal) return GET(`/ai-search?${buildSearchQuery(query, options)}`, true, { signal: options.signal })
  return await GET(`/ai-search?${buildSearchQuery(query, options)}`, true);
}
